import { getInquiryMasterData } from 'src/api/inquiry';
import {
  INQUIRY_MASTER_DATA,
} from './constants';

export const setMasterData = () => async (dispatch) => {
  const response = await getInquiryMasterData();
  if (response.isSuccess) {
    dispatch({
      type: INQUIRY_MASTER_DATA,
      data: response.data,
    });
  }
};
